import React, {
    Component,
    createContext
} from 'react';
import { getUserDetails, login as userLogin, logout as userLogout } from './../../infrastructure/requests';
import { removeAllStorage } from './../../infrastructure/storageService';
import mixpanel, { Events as MPEvents } from '../../infrastructure/mixpanel';


const SessionContext = createContext({ user: undefined, loggedIn: undefined, ready: false });

export function hasCookie() {
    return document.cookie.split(';').map(s => s.trim()).filter(s => s.startsWith('token=') && s.length > 6).length > 0;
}

export function removeCookie() {
    document.cookie = 'token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
}
class SessionProvider extends Component {
    state = {
        loggedIn: undefined,
        user: undefined,
        ready: false,
    }

    login = async (username, password) => {
        await userLogin(username, password);
        mixpanel.track(MPEvents.HOME_LOGIN, { username });
        await this.refreshUserData();
    }

    logout = async () => {
        await userLogout();
        removeAllStorage('as_user');
        mixpanel.track(MPEvents.HOME_LOGOUT, { user: this.state.user });
        await this.refreshUserData();
    }

    refreshUserData = async () => {
        // Check if user has cookie
        if (hasCookie()) {
            await this.setState({
                ready: false,
            });

            // Get the user details
            let user = undefined;
            let loggedIn = undefined;

            try {
                user = await getUserDetails();
                loggedIn = true;

            } catch (error) {
                removeCookie();
                loggedIn = false;
            }
            await this.setState({
                ready: true,
                loggedIn,
                user
            });
        } else {
            this.setState({
                ready: true,
                loggedIn: false,
                user: undefined
            });
            removeAllStorage();
        }
    }

    componentDidMount = async () => {
        this.refreshUserData();
    }

    render() {
        const { children } = this.props;
        const { loggedIn, user, ready } = this.state;

        return (
            <SessionContext.Provider value={{
                loggedIn,
                user,
                ready,
                login: this.login,
                logout: this.logout,
                refreshUserData: this.refreshUserData
            }}>
                {children}
            </SessionContext.Provider>
        );
    }
}

export default SessionProvider;

export const SessionConsumer = SessionContext.Consumer;